const genAiQ = {
    topic: 'Gen AI Theory',
    questions: [
        {
            id: 1,
            question: `Explain transformer architecture in detail.`,
            diffculty: `Medium`
        },
        {
            id: 2,
            question: `What is the difference between self attention, cross attention and multihead attention?`,
            difficulty: `Medium`
        },
        {
            id: 3,
            question: `We have 3 types of transformer models: encoder only, decoder only and encoder decoder. Give the example of each and in which use case we should consider them.`,
            difficulty: `Medium`
        },
        {
            id: 4,
            question: `What are the techniques of LLM Finetuning. Explain in detail.`,
            difficulty: `Hard`
        },
        {
            id: 5,
            question: `What are the evaluation metrics used to evaluate the LLM models?`,
            difficulty: `Easy`
        },
        {
            id: 6,
            question: `What are RAGs, Embeddings, Vector DB, Reindexing?`,
            difficulty: `Easy`
        },
        {
            id: 7,
            question: `What are the metrics we need to use for evaluating RAGs?`,
            difficulty: `Medium`
        },
        {
            id: 8,
            question: `Explain different types of prompting techniques. In which use case can we use them?`,
            difficulty: `Easy`
        },
        {
            id: 9,
            question: `Explain different types of indexing in Vector DB.`,
            difficulty: `Medium`
        },
        {
            id: 10,
            question: `When should we go for LLM Finetuning, RAG, Full finetuning?`,
            difficulty: `Medium`
        },
        {
            id: 11,
            question: `What is Quantization? What are the types of quantization and why do we use them?`,
            difficulty: `Medium`
        },
        {
            id: 12,
            question: `What are temp, top-p, top-k? How are they related to each other? Explain with example?`,
            difficulty: `Easy`
        },
        {
            id: 13,
            question: `How, why and in which use case should we fine tune Embedding models?`,
            difficulty: `Easy`
        },
        {
            id: 14,
            question: `What is context window, chunk size and chunk overlap?`,
            difficulty: `Easy`
        },
        {
            id: 15,
            question: `What are the different chunking strategies and when to use which?`,
            difficulty: `Medium`
        },
        {
            id: 16,
            question: `How to decide if a specific LLM model is better for our use case?`,
            difficulty: `Medium`
        },
        {
            id: 17,
            question: `What are the things we need to consider while productionizing the RAG solution?`,
            difficulty: `Medium`
        },
        {
            id: 18,
            question: `What are the differences between RAG, Agents and MCP?`,
            difficulty: `Easy`
        },
        {
            id: 19,
            question: `What are the key differences between LangChain, LlamaIndex, and Chainlit and when would you use each?`,
            difficulty: `Easy`
        },
        {
            id: 20,
            question: `How does LoRA (Low-Rank Adaptation) help optimize model performance?`,
            difficulty: `Easy`
        },
        {
            id: 21,
            question: `Can you explain the concept of zero-shot learning in Generative AI?`,
            difficulty: `Easy`
        },
    ]
}

export default genAiQ;